import { DataTypeForm2 } from "../../../../../features/data-types"
import { ModalId, useUIActions } from "../../../../../features/ui"
import { HoardOrder } from "../../../state/types"
import { FormField, FieldType } from "../../../../../features/ui"
import { Modal } from "../../../../../features/ui/components/modal/modal"
import { useActions } from "../hoard-form/actions" 

type Props = {
    hoard: HoardOrder
}

export const EditHoardDueDateModal = ({ hoard }: Props) => {
    const { submitHoard } = useActions()
    const { closeModal } = useUIActions()

    const fields: FormField[] = [
        {
            name: 'dueDate',
            type: FieldType.DATE,
            label: 'Nueva Fecha Límite',
            defaultValue: hoard.dueDate,
            min: new Date(),
            focus: true,
            labelSpace: 4 
        }
    ]

    const handleClose = () => closeModal(ModalId.EDIT_HOARD_DUE_DATE)

    const onSubmit = async (data: any) => {
        await submitHoard(
            { ...hoard, dueDate: data.dueDate },
            hoard.branchId,
            hoard.items,
            hoard.value,
            hoard.deliveryData,
            hoard.latePayment,
            hoard.notes,
            undefined,
            false
        )
        handleClose()
    }

    return (
        <Modal
            modalId={ModalId.EDIT_HOARD_DUE_DATE}
            title="¿Deseas modificar la Fecha Límite de este Acopio?"
            widthSize="m"
            hideCancel
        >
            <DataTypeForm2
                formId="edit-due-date-form"
                fields={fields}
                createMode={false}
                onSubmit={onSubmit}
                onCancel={handleClose}
            />
        </Modal>
    )
}